import React from 'react'
import { Box, Container, Grid, IconButton, Typography } from '@mui/material'
import { Instagram, WhatsApp, YouTube } from '@mui/icons-material'

const DiscordIcon = () => (
  <svg width="28" height="28" viewBox="0 0 127.14 96.36" fill="currentColor">
    <path d="M107.7,8.07A105.15,105.15,0,0,0,81.47,0a72.06,72.06,0,0,0-3.36,6.83A97.68,97.68,0,0,0,49,6.83,72.37,72.37,0,0,0,45.64,0,105.89,105.89,0,0,0,19.39,8.09C2.79,32.65-1.71,56.6.54,80.21h0A105.73,105.73,0,0,0,32.71,96.36,77.7,77.7,0,0,0,39.6,85.25a68.42,68.42,0,0,1-10.85-5.18c.91-.66,1.8-1.34,2.66-2a75.57,75.57,0,0,0,64.32,0c.87.71,1.76,1.39,2.66,2a68.68,68.68,0,0,1-10.87,5.19,77,77,0,0,0,6.89,11.1A105.25,105.25,0,0,0,126.6,80.22h0C129.24,52.84,122.09,29.11,107.7,8.07ZM42.45,65.69C36.18,65.69,31,60,31,53s5-12.74,11.43-12.74S54,46,53.89,53,48.84,65.69,42.45,65.69Zm42.24,0C78.41,65.69,73.25,60,73.25,53s5-12.74,11.44-12.74S96.23,46,96.12,53,91.08,65.69,84.69,65.69Z" />
  </svg>
)

const Footer: React.FC = () => {
  const handleWhatsAppWarzone = () => {
    window.open('https://chat.whatsapp.com/JL9BlT8IyluCtjwLiQGJj8', '_blank')
  }

  const handleInstagramWarzone = () => {
    window.open('https://www.instagram.com/arkwarzoneservers?igsh=MTNvYTluMHY4MXd2Nw==', '_blank')
  }

  const handleDiscordWarzone = () => {
    window.open('https://discord.gg/a7T5WZvr', '_blank')
  }

  const handleYouTubeWarzone = () => {
    window.open('https://www.youtube.com/@ark_warzone_servers', '_blank')
  }

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.paper',
        borderTop: '2px solid',
        borderColor: 'primary.main',
        py: 6,
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  background: 'linear-gradient(45deg, #00e676 25%, #00d9ff 55%, #ff6d00 90%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  mb: 3
                }}
              >
                🎮 WARZONE Servers
              </Typography>
              <Typography variant="h6" color="text.primary" paragraph>
                Infraestrutura otimizada para Palworld e outros jogos, com foco em estabilidade, desempenho e comunidade.
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
                🌟 Servidores otimizados e estáveis
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
                🛡️ Proteção DDoS e backup automático
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
                💬 Suporte técnico e comunidade ativa
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
                ⚡ Performance de alta velocidade
              </Typography>
              <Typography variant="body1" color="text.secondary">
                🎯 Atualizações e melhorias constantes
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  color: 'secondary.main',
                  mb: 3
                }}
              >
                📱 Conecte-se Conosco
              </Typography>
              <Typography variant="h6" color="text.primary" paragraph>
                Siga o WARZONE Servers nas redes sociais para novidades, promoções e suporte em tempo real.
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  gap: 3,
                  justifyContent: { xs: 'center', md: 'flex-start' },
                  mb: 3,
                  flexWrap: 'wrap'
                }}
              >
                <IconButton
                  onClick={handleWhatsAppWarzone}
                  sx={{
                    bgcolor: '#25D366',
                    color: 'white',
                    width: 60,
                    height: 60,
                    '&:hover': { bgcolor: '#128C7E', transform: 'scale(1.08)' },
                    transition: 'all 0.25s ease'
                  }}
                >
                  <WhatsApp sx={{ fontSize: 28 }} />
                </IconButton>

                <IconButton
                  onClick={handleInstagramWarzone}
                  sx={{
                    bgcolor: '#E4405F',
                    color: 'white',
                    width: 60,
                    height: 60,
                    '&:hover': { bgcolor: '#C13584', transform: 'scale(1.08)' },
                    transition: 'all 0.25s ease'
                  }}
                >
                  <Instagram sx={{ fontSize: 28 }} />
                </IconButton>

                <IconButton
                  onClick={handleDiscordWarzone}
                  sx={{
                    bgcolor: '#5865F2',
                    color: 'white',
                    width: 60,
                    height: 60,
                    '&:hover': { bgcolor: '#4752C4', transform: 'scale(1.08)' },
                    transition: 'all 0.25s ease'
                  }}
                >
                  <DiscordIcon />
                </IconButton>

                <IconButton
                  onClick={handleYouTubeWarzone}
                  sx={{
                    bgcolor: '#FF0000',
                    color: 'white',
                    width: 60,
                    height: 60,
                    '&:hover': { bgcolor: '#CC0000', transform: 'scale(1.08)' },
                    transition: 'all 0.25s ease'
                  }}
                >
                  <YouTube sx={{ fontSize: 28 }} />
                </IconButton>
              </Box>

              <Typography variant="body1" color="text.secondary">
                💬 Suporte e avisos em primeira mão
              </Typography>
              <Typography variant="body1" color="text.secondary">
                🎁 Promoções exclusivas para seguidores
              </Typography>
              <Typography variant="body1" color="text.secondary">
                📢 Novos recursos e atualizações
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                  color: 'primary.main',
                  mb: 3
                }}
              >
                🚀 Por que WARZONE?
              </Typography>

              <Typography variant="h6" color="text.primary" paragraph>
                Experiência, infraestrutura e comunidade.
              </Typography>

              <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                🏆 <strong>Experiência comprovada</strong> - Operação madura e consistente
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                🔧 <strong>Tecnologia de ponta</strong> - Infraestrutura moderna e confiável
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                👥 <strong>Comunidade ativa</strong> - Canais para dúvidas e novidades
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                ⚡ <strong>Performance superior</strong> - Foco em estabilidade e baixa latência
              </Typography>
              <Typography variant="body1" color="text.secondary">
                🛡️ <strong>Segurança</strong> - Proteção contra ataques e rotinas de backup
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            borderTop: '1px solid',
            borderColor: 'divider',
            mt: 3,
            pt: 2,
            textAlign: 'center'
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} WARZONE Servers. Todos os direitos reservados.
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
